module.exports = __webpack_public_path__ + "img/PRNT_00_mono_AE_00004.5abf4b32.png";